// lang selecter

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {};
    const input = this.querySelector(
      'input[name="language_code"], input[name="country_code"]'
    );
    if (input) {
      this.elements.input = input;
      this.elements.button = this.querySelector("button");
      this.elements.panel = this.querySelector("ul");
      this.elements.button.addEventListener(
        "click",
        this.openSelector.bind(this)
      );
      this.elements.button.addEventListener(
        "blur",
        this.closeSelector.bind(this)
      );
      this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
      this.querySelectorAll("a").forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this))
      );
    }
  }

  setupElements() {
    this.elements.input = this.querySelector(
      'input[name="language_code"], input[name="country_code"]'
    );
    this.elements.button = this.querySelector("button");
    this.elements.panel = this.querySelector("ul");
  }

  // パネルを非表示にするメソッド
  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", "");
  }

  // ESC キーが押されたときにパネルを非表示にするメソッド
  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.hidePanel();
    this.elements.button.focus();
  }

  // リストアイテムがクリックされたときに入力フィールドの値を設定するメソッド
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) {
      form.submit();
    }
  }

  // ボタンをクリックしてパネルを表示するメソッド
  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute("hidden");
    this.elements.button.setAttribute(
      "aria-expanded",
      this.elements.panel.hidden.toString()
    );
  }

  // パネル外の領域がクリックされたときにパネルを非表示にするメソッド
  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define("localization-form", LocalizationForm);


// const header = $(".site-header");

// // ヘッダーの高さ
// let headerHeight = header.outerHeight();
// // スクロール量
// let currentPos = $(window).scrollTop();
// // ヘッダーを表示する高さ = ヘッダーの高さ + 任意の値
// let showHeight = headerHeight;

// $(window).on("scroll", function () {
//   // スクロール量を更新
//   let scroll = $(this).scrollTop();

//   if (showHeight < scroll) {
//     header.addClass("fixed shadow");
//   } else {
//     header.removeClass("fixed shadow");
//   }

//   // スクロール方向によってヘッダーの表示/非表示を切り替え
//   if (currentPos < scroll) {
//     header.css("top", 0);
//   } else if (0 < scroll < 120) {
//     header.css("top", 0);
//     console.log(currentPos);

//   } else {
//     header.css("top", -headerHeight);
//     console.log(currentPos);
//   }

//   // 現在のスクロール位置を更新
//   currentPos = scroll;
// });
const header = $(".site-header");

// ヘッダーの高さ
let headerHeight = header.outerHeight();
// スクロール量
let currentPos = $(window).scrollTop();
// ヘッダーを表示する高さ = ヘッダーの高さ + 任意の値
let showHeight = headerHeight;

$(window).on("scroll", function () {
  // スクロール量を更新
  let scroll = $(this).scrollTop();
  if (showHeight < scroll) {
    header.addClass("fixed shadow");
  } else {
    header.removeClass("fixed shadow");
  }

  // スクロール方向によってヘッダーの表示/非表示を切り替え
  if (currentPos > scroll) {
    header.css("top", 0);
    } else if (0 < showHeight && scroll < showHeight) {
      header.css("top", 0);
    } else {
      header.css("top", -headerHeight);
    }
  // 現在のスクロール位置を更新
  currentPos = scroll;
});



$(function () {
  //クリックで動く
  $("#lang-btn").click(function () {
    $(this).toggleClass("active");
    $(this).next("#lang-open").slideToggle();
  });
});

// sp language switcher
$(function () {
  $("#LanguageSelectorMobile").change(function () {
    if ($(this).val() != "") {
      window.location.href = $(this).val();
    }
  });
});

$(function () {
  //クリックで動く
  $(".dropdown-toggle").click(function () {
    $(this).toggleClass("active");
    $(this).next().toggleClass("active");
  });
});
$(document).on("click", function (e) {
  if (
    !$(e.target).closest(".dropdown-menu.active, .dropdown-toggle.active").length
  ) {
    $(".dropdown-menu.active, .dropdown-toggle.active").removeClass("active");
  }
});

// Medium Zoom
// ・ズーム対象の画像があるページでだけ実行する
// ・ライブラリが未読み込みなら、その場で読み込んでから適用する(未定義エラーを防ぐ)
(function () {
  var SELECTOR = ".medium-zoom img";
  var LIB_URL =
    "https://cdn.jsdelivr.net/npm/medium-zoom@1.1.0/dist/medium-zoom.min.js";
  var OPTIONS = { margin: 24, background: "#292d3d", scrollOffset: 0 };

  function applyZoom() {
    var images = document.querySelectorAll(SELECTOR);
    if (!images.length || typeof window.mediumZoom !== "function") return;
    window.mediumZoom(images, OPTIONS);
  }

  function initZoom() {
    if (!document.querySelector(SELECTOR)) return; // 対象画像がなければ何もしない
    if (typeof window.mediumZoom === "function") { applyZoom(); return; }
    var script = document.createElement("script");
    script.src = LIB_URL;
    script.async = true;
    script.onload = applyZoom;
    document.head.appendChild(script);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initZoom);
  } else {
    initZoom();
  }
})();